import OwnerCard from "./OwnerCard";
import AnnuitantCard from "./AnnuitantCard";
import {
  getAllOwnersFromParties,
  getAllAnnuitantsFromParties,
} from "js/utilities";

export default function OwnerAndInsuredCard({ data }) {
  const owners = getAllOwnersFromParties(data.parties);
  const annuitants = getAllAnnuitantsFromParties(data.parties);

  return (
    <>
      {owners.length > 0 && <OwnerCard owners={owners} />}

      {annuitants.length > 0 && (
        <AnnuitantCard annuitants={annuitants} policy={data} />
      )}
    </>
  );
}
